import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f19fcb34&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f19fcb34')) {
      api.createRecord('f19fcb34', component.options)
    } else {
      api.reload('f19fcb34', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f19fcb34&", function () {
      api.rerender('f19fcb34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8YQZm2NC2f3Pu/JS/comp/FavElement.vue"
export default component.exports